'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Fragment, Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Link from 'Pure/Link';
import { URL } from 'Shared/Routes';
const item_styles = theme => ({
  root: {
    color: '#fff',
    padding: '6px 16px',
    height: 'auto',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: '#234D80'
    }
  },
  'selected': {
    '&$selected': {
      color: '#fff',
      backgroundColor: '#3F6096',
      fontWeight: '500'
    },
    '&$selected:hover': {
      backgroundColor: '#234D80'
    }
  }
});
const sub_item_styles = theme => ({
  root: {
    color: '#fff',
    padding: '6px 16px',
    height: 'auto',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: '#234D80'
    }
  },
  'selected': {
    '&$selected': {
      color: '#fff',
      backgroundColor: '#3F6096',
      fontWeight: '500'
    },
    '&$selected:hover': {
      backgroundColor: '#3F6096'
    }
  }
});
class CustomMenuItem extends Component {
  render() {
    return /*#__PURE__*/React.createElement(MenuItem, this.props);
  }
}
const StyledMenuItem = withStyles(item_styles)(CustomMenuItem);
const StyledSubMenuItem = withStyles(sub_item_styles)(CustomMenuItem);
const text_styles = {
  root: {
    color: 'inherit',
    padding: '0 16px !important'
  }
};
class CustomListItemText extends Component {
  render() {
    return /*#__PURE__*/React.createElement(ListItemText, this.props);
  }
}
const StyledListItemText = withStyles(text_styles)(CustomListItemText);
const icon_styles = {
  root: {
    color: 'inherit',
    minWidth: '0px'
  }
};
class CustomListItemIcon extends Component {
  render() {
    return /*#__PURE__*/React.createElement(ListItemIcon, this.props);
  }
}
const StyledListItemIcon = withStyles(icon_styles)(CustomListItemIcon);
export default class SidebarMenuItem extends Component {
  render = () => {
    const component = this,
      props = this.props;
    let output;
    const ItemComponent = props.level > 0 ? StyledSubMenuItem : StyledMenuItem;
    let padding_styles = {};
    if (props.level > 0) {
      padding_styles.paddingLeft = 20 + props.level * 20;
    }
    if (Object.keys(props.sub_items || {}).length === 0) {
      const Icon = props.icon;
      const href = props.url || URL(props.action);
      output = /*#__PURE__*/React.createElement(ItemComponent, {
        selected: props.selected || false,
        style: padding_styles,
        href: href,
        component: Link
      }, props.icon ? /*#__PURE__*/React.createElement(StyledListItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
        className: "menu-icon"
      })) : undefined, /*#__PURE__*/React.createElement(StyledListItemText, {
        inset: true,
        primary: props.label
      }));
      return output;
    }
    const sub_items = Object.keys(props.sub_items).map(function (name) {
      const sub_item = props.sub_items[name] || {};
      const href = sub_item.url || URL(sub_item.action);
      let output = /*#__PURE__*/React.createElement(SidebarMenuItem, _extends({}, sub_item, {
        url: href,
        key: href,
        onClick: (e, link) => props.onClick(e, {
          ...sub_item
        })
      }));
      return output;
    });
    const Icon = props.icon;
    output = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ItemComponent, {
      button: true,
      onClick: e => props.onClick(e, {
        ...props
      }),
      selected: props.selected || false,
      style: padding_styles
    }, props.icon ? /*#__PURE__*/React.createElement(StyledListItemIcon, null, /*#__PURE__*/React.createElement(Icon, {
      className: "menu-icon"
    })) : undefined, /*#__PURE__*/React.createElement(StyledListItemText, {
      inset: true,
      primary: props.label
    }), props.open ? /*#__PURE__*/React.createElement(ExpandLess, null) : /*#__PURE__*/React.createElement(ExpandMore, null)), /*#__PURE__*/React.createElement(Collapse, {
      in: props.open || false,
      timeout: "auto",
      unmountOnExit: true
    }, /*#__PURE__*/React.createElement(MenuList, {
      disablePadding: true
    }, sub_items)));
    return output;
  };
}
